/*
 * Some copy is written as HTML in Airtable so that a link can sit inside a
 * sentence: the About bio, and the line under each Editorial heading.
 *
 * A link that leaves the site should open beside it rather than in place of it.
 * Rather than ask for those attributes to be typed into every anchor in
 * Airtable, they are added here on the way to the page. Anchors that already
 * name a target are left alone, and so are links within the site, which are
 * meant to be followed in the same tab.
 */
export const withExternalLinks = (html = '') => html.replace(
  /<a\s+(?![^>]*\btarget=)([^>]*href=["']https?:)/gi,
  '<a target="_blank" rel="noopener noreferrer" $1',
);

export default withExternalLinks;
